export default {
  CHAT_APP: 'ChatApp',
  CHAT_APP_GUEST: 'ChatAppGuest',
  CHAT_APP_HOME: 'ChatAppHome',
  CHAT_APP_LOGIN: 'ChatAppLogin',
}



// WEBPACK FOOTER //
// ./src/constants/routeNames.js